import { useCreateResource__ALPHA } from '@cube3/state/src/redux/components/Hooks/useCreateResource';
import { addFormId } from '@cube3/state/src/redux/middleware/redux-form-middleware';

import { useCallback, useRef } from 'react';
import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { Asset } from '@cube3/common/model/schema/resources/asset';
import { getErrorMessage } from '@cube3/forms/src/utils/getErrorMessage';

export const useBroadcastActions = <IP extends {}>({
  assets,
  getForm
}: {
  assets: Asset[];
  getForm: (id: string) => string;
}) => {
  const [workspaceId] = useCurrentWorkspace();
  const [createBatchResource, createBatchStatus, createBatchError] =
    useCreateResource__ALPHA(
      useRef({
        resourceType: 'export-batch' as const,
        ancestor: { type: 'workspace' as const, id: workspaceId },
        relationship: 'export-batches',
        cacheInvalidator: (r) => [r],
        actionDecorators: [
          ...assets.map((a) =>
            addFormId(getForm(a.id), {
              formState: undefined,
              useRequestStatus: true,
              delegate: true
            })
          )
        ]
      }).current
    );

  const createBatch = useCallback(
    ({ recipients, exports }: { recipients?: string[]; exports: IP[] }) => {
      createBatchResource({
        type: 'export-batch',
        exports: exports,
        notification_recipients: recipients.length ? recipients : undefined
      });
    },
    [createBatchResource]
  );

  return {
    createBatch,
    createBatchStatus,
    errorMessage: createBatchError ? getErrorMessage(createBatchError) : null
  };
};
